import styled, {css} from 'styled-components'

export const StyledTherapistCard = styled.div<{
    $checked: boolean
    $disabled: boolean
}>(
    ({theme: {palette, opacities, spacing, typography}, $checked, $disabled}) => css`
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        gap: ${spacing * 2}px;
        width: 100%;
        padding: ${spacing * 2}px;
        background-color: ${$checked ? palette.primary['50'] : palette.neutral.white};
        border-radius: 8px;
        border-width: 1px;
        border-style: solid;
        border-color: ${$checked ? palette.primary['400'] : `${palette.neutral.black}${opacities[10]}`};
        color: ${palette.neutral['500']};
        cursor: ${$disabled ? 'not-allowed' : 'pointer'};
        ${typography.textSm};

        & > svg {
            fill: ${palette.primary['500']};
            visibility: ${$checked ? 'visible' : 'hidden'};
        }
        & h4 {
            color: ${palette.neutral['950']};
            font-weight: 500;
        }
        & b {
            color: ${palette.neutral['950']};
            font-weight: 500;
        }

        ${$disabled &&
        css`
            opacity: 50%;
        `}
    `
)
